module.exports = __webpack_public_path__ + "img/recruitmentGroup.3c596219.svg";